import React from 'react';
import {Provider} from "react-redux";
import configure from "../../../store/configure";
import CashChargedComp from "../container/CashChargedComp";
import Layout from "../../../component/layout/Layout";

const CashChargePage = () => {
    return (
        <Provider store={configure}>
            <Layout>
                <CashChargedComp />
            </Layout>
        </Provider>
    );
};

export default CashChargePage;
